export const searchNewsId = "api::news.news";
export const searchAboutId = "api::about-us.about-us";
export const searchHomeId = "api::homepage.homepage";
export const searchFreightId = "api::freight.freight";
export const searchTermsId = "api::terms-and-conditions.terms-and-conditions";
export const searchPrivacyId = "api::privacy-policy.privacy-policy";
export const searchCookiesId = "api::cookies-policy.cookies-policy";
export const searchContactId = "api::contact.contact";
export const searchProductsId = "api::products.products";
export const searchSingleProductId = "api::single-product.single-product";
export const searchGovernanceId = "api::corporate-governance.corporate-governance";
export const searchCarierId = "api::carrier.carrier";

export const filtersList: Record<string, string> = {
    [searchNewsId]: "news",
    [searchFreightId]: "catalog",
    [searchSingleProductId]: "catalog",
    [searchCarierId]: "catalog",
    [searchProductsId]: "pages",
    [searchAboutId]: "pages",
    [searchHomeId]: "pages",
    [searchTermsId]: "pages",
    [searchPrivacyId]: "pages",
    [searchContactId]: "pages",
    [searchCookiesId]: "pages",
}